// extracted by mini-css-extract-plugin
export default {"category":"Categories_category__IBkA2","header":"Categories_header__iGK8u","title":"Categories_title__XTnvk"};